var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { getFlattenedChildren } from '../_internal/getFlattenedChildren';
import { useParentLayout } from '../Layout';
import { LayoutChild } from '../Layout';
import { useCurrentBackground } from '../useCurrentBackground';
import { ActionBarContainer, ActionBarContent } from './ActionBar.style';
export var ActionBar = React.forwardRef(function (props, ref) {
    var rawChildren = props.children, rest = __rest(props, ["children"]);
    var parentLayout = useParentLayout();
    var backgroundColor = useCurrentBackground();
    var children = getFlattenedChildren(rawChildren);
    React.useLayoutEffect(function () {
        if (parentLayout.isInLayout) {
            return parentLayout.registerChild(LayoutChild.ActionBar);
        }
    }, [parentLayout]);
    return (React.createElement(ActionBarContainer, __assign({ backgroundColor: backgroundColor, "data-in-layout": parentLayout.isInLayout }, rest, { ref: ref }),
        React.createElement(ActionBarContent, { "data-count": React.Children.count(children) }, React.Children.map(children, function (child, index) { return (React.createElement(React.Fragment, { key: index }, child)); }))));
});
//# sourceMappingURL=ActionBar.js.map